import { render, staticRenderFns } from "./RecordTypeface.vue?vue&type=template&id=5a602114&"
import script from "./RecordTypeface.vue?vue&type=script&lang=js&"
export * from "./RecordTypeface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports